import {
  REDEEM_QR_REQUEST,
  REDEEM_QR_SUCCESS,
  REDEEM_QR_FAIL,
} from "../actionTypes";
import {
  QR_STATUS_REQUEST,
  QR_STATUS_SUCCESS,
  QR_STATUS_FAIL,
   FETCH_OTP_REQUEST,
  FETCH_OTP_SUCCESS,
  FETCH_OTP_FAIL,
  FETCH_CUSTOMER_DETAILS_REQUEST,
  FETCH_CUSTOMER_DETAILS_SUCCESS,
  FETCH_CUSTOMER_DETAILS_FAIL,
  REDEEM_PROMOTIONAL_QR_REQUEST,
  REDEEM_PROMOTIONAL_QR_SUCCESS,
  REDEEM_PROMOTIONAL_QR_FAIL
} from "../actionTypes";
import axiosInstance from "../../api/axiosInstance";
import { toast } from "react-toastify";
export const checkQRStatus = (qr_id) => async (dispatch) => {
  try {
    dispatch({ type: QR_STATUS_REQUEST });

    const { data } = await axiosInstance.post("/api/qr-status/", { qr_id });

    dispatch({ type: QR_STATUS_SUCCESS, payload: data });
    const suceessMessage =
      data?.message || "QR Code status fetched successfully!";
    // toast.success(suceessMessage);
  } catch (error) {
    console.log("QR Status Error:", error.response?.data || error.message);
    dispatch({
      type: QR_STATUS_FAIL,
      payload: error.response?.data || error.message,
    });
    // const errorMessage =
    //   error.response?.data?.message || "Failed to fetch QR code status.";
    // toast.error(errorMessage);
  }
};

export const redeemQr = (qr_id, data) => async (dispatch) => {
  try {
    dispatch({ type: REDEEM_QR_REQUEST });

    const response = await axiosInstance.post(`/api/redeem-qr/${qr_id}/`, data);
     const resData = response.data;
    // dispatch({ type: REDEEM_QR_SUCCESS, payload: response.data });
    // const successMessage =
    //   response.data?.message || "QR Code redeemed successfully!";
    const transferStatus = resData?.cashfree_status?.transfer_payment?.status;
    const isActualFailure = resData?.success === 400 || transferStatus === "FAILED";

    if (isActualFailure) {
      dispatch({ type: REDEEM_QR_FAIL, payload: resData });
    } else {
      dispatch({ type: REDEEM_QR_SUCCESS, payload: resData });
    }
    // toast.success(successMessage);
  } catch (error) {
    dispatch({
      type: REDEEM_QR_FAIL,
      payload: error.response ? error.response.data : error.message,
    });
    // const errorMessage =
    //   error.response?.data?.message || "Failed to redeem QR code.";
    // toast.error(errorMessage);
  }
};

export const redeemPromotionalQr = ( data) => async (dispatch) => {
  try {
    dispatch({ type: REDEEM_PROMOTIONAL_QR_REQUEST });

    const response = await axiosInstance.post(`api/promotional-redemption/`, data);

    dispatch({ type: REDEEM_PROMOTIONAL_QR_SUCCESS, payload: response.data });
  } catch (error) {
    dispatch({
      type: REDEEM_PROMOTIONAL_QR_FAIL,
      payload: error.response ? error.response.data : error.message,
    });
  }
};

export const sendOTP = (qr_id, otpData) => async (dispatch) => {
  try {
    dispatch({ type: FETCH_OTP_REQUEST });

    const payload = {
      
      mobile: otpData.mobile,
      
    };

    const response = await axiosInstance.post(
      "/api/send-otp/",
      payload
    );

    dispatch({
      type: FETCH_OTP_SUCCESS,
      payload: response.data,
    });

    const successMessage = response.data.message || "OTP sent successfully";
    toast.success(successMessage);

    return { success: true, data: response.data };
  } catch (error) {
    const errorMessage =
      error.response?.data?.message ||
      error.response?.data?.detail ||
      error.message ||
      "Failed to send OTP";

    dispatch({
      type: FETCH_OTP_FAIL,
      payload: errorMessage,
    });

    toast.error(errorMessage);
    return { success: false, error: errorMessage };
  }
};
export const getConsumerDetails = (mobile) => async (dispatch) => {
  try {
    dispatch({ type: FETCH_CUSTOMER_DETAILS_REQUEST });

    const { data } = await axiosInstance.get(`/api/customer-details/`, {
      params: { mobile },
    });

    dispatch({ type: FETCH_CUSTOMER_DETAILS_SUCCESS, payload: data });
    return { success: true, data };
  } catch (error) {
    const errorMessage =
      error.response?.data?.message ||
      error.response?.data?.detail ||
      error.message ||
      "Failed to fetch customer details.";

    dispatch({ type: FETCH_CUSTOMER_DETAILS_FAIL, payload: errorMessage });
    toast.error(errorMessage);
    return { success: false, error: errorMessage };
  }
};